import './Payments.css';

import { IonCard, IonCardContent, IonContent, IonIcon, IonLabel, IonPage, IonSegment, IonSegmentButton, IonSlide, IonSlides, useIonViewDidEnter, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';

import ListItem from '../../../components/list/ListItem';
import LoadingContainer from '../../../components/loading/LoadingContainer';
import LayoutGap from '../../../layouts/LayoutGap';
import Toolbar from '../../../layouts/Toolbar';
import { PaymentsGetAction } from '../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { arrowBackCircleOutline, cardOutline, cashOutline, wifiOutline } from 'ionicons/icons';
import Segment from '../../../components/segments/Segment';
import Container from '../../../layouts/Container';
import SlideContent from '../../../components/slide-content/SlideContent';
import { Empty } from '../../../layouts/errors/Empty';

const Payments: React.FC = () => {
    const slideValues = ["donation", "transfer"]
    const [defaultSlide, setDefaultSlide] = useState("donation");
    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const dispatch = useAppDispatch()

    const { loading, payments } = useAppSelector(state => state.paymentsReducer)

    useEffect(() => {
        dispatch(PaymentsGetAction())
    }, [dispatch])

    useEffect(() => {
        if (payments != null && !loading) {

        }
    }, [loading])

    const segmentClickHandler = (value: any) => {
        setDefaultSlide(value)

        let index = slideValues.findIndex((item) => {
            return item == value
        })

        sliderRef.current?.slideTo(index);
    }

    const slideChangeHandler = async () => {
        var index = await sliderRef.current?.getActiveIndex()

        setDefaultSlide(slideValues[index as number])
    }

    return <LoadingContainer loading={loading}>
        <IonPage className="payments">
            <Toolbar title="حمایت ها" hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <Segment defaultSlide={defaultSlide} change={(e: any) => segmentClickHandler(e.detail.value)}>
                    <IonSegmentButton layout="icon-start" value="donation">
                        <IonIcon icon={wifiOutline} size="small" />
                        <IonLabel>آنلاین</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton layout="icon-start" value="transfer">
                        <IonIcon icon={cardOutline} size="small" />
                        <IonLabel>واریز شده</IonLabel>
                    </IonSegmentButton>
                </Segment>

                <IonSlides ref={sliderRef} onIonSlideDidChange={slideChangeHandler}>
                    <IonSlide>
                        <SlideContent type="segment">
                            <Empty text="پرداخت آنلاینی ثبت نشده است!" icon={cardOutline} length={payments.donations?.length}>
                                <div>
                                    {payments.donations?.map((item: any) => {
                                        let color = "";

                                        switch (item.status) {
                                            case 0: color = "danger"; break;
                                            case 1: color = "success"; break;
                                        }

                                        return <ListItem title={item.transaction_id} value={item.price} valueText="مبلغ پرداختی"
                                            status={item.status_title} date={item.date} dateTitle={item.type} color={color}
                                            footerIcon={arrowBackCircleOutline}
                                            link={item.project_id != 0 ? `/account/payments/campaign/${item.project_id}` : undefined} />
                                    })}
                                </div>
                            </Empty>
                        </SlideContent>
                    </IonSlide>
                    <IonSlide>
                        <SlideContent type="segment">
                            <Empty text="واریزی ثبت نشده است!" icon={cashOutline} length={payments.deposits?.length}>
                                <div>
                                    {payments.deposits?.map((item: any) => {
                                        let color = "";

                                        switch (item.status) {
                                            case 0: color = "danger"; break;
                                            case 1: color = "success"; break;
                                            case 2: color = "info"; break;
                                        }

                                        return <ListItem title={item.tracking_code} value={item.price} valueText="مبلغ واریزی"
                                        status={item.status_title} date={item.date} dateTitle={item.transfer_type} color={color}
                                        footerIcon={arrowBackCircleOutline}
                                        link={item.project_id != 0 ? `/account/payments/campaign/${item.project_id}` : undefined} />
                                    })}
                                </div>
                            </Empty>
                        </SlideContent>
                    </IonSlide>
                </IonSlides>
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default Payments